import { Grid, Paper, TextField } from "@mui/material";
import React, { Fragment } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CountrySelector from "../../../../components/form/CountrySelector";
import { FIELDS } from "./enums/ClinicTextFields";
import { isMobilePhone } from "../../../auth/utils/PhoneNumberValidation";
import { isValidWebsiteUrl } from "../../../../utils/UrlValidation";

export default function ClinicNameForm({ clinic }) {
  const { t } = useTranslation();
  const {
    setValue,
    formState: { errors },
    control,
  } = useFormContext();

  React.useEffect(() => {
    Object.keys(clinic).forEach((key) => {
      if (clinic[key] !== undefined && clinic[key] !== null) {
        setValue(`clinic.${key}`, String(clinic[key]));
      }
    });
  }, [clinic, setValue]);
  const url = "clinic.url";

  return (
    <Fragment>
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={3}>
          {FIELDS.map((textfield) => (
            <Grid key={textfield.register} item xs={6}>
              <Controller
                name={`clinic.${textfield.register}`}
                control={control}
                rules={{
                  required: t("CantBeEmpty"),
                  validate:
                    textfield.register === "phoneNumber"
                      ? (value) =>
                          isMobilePhone(value) || t("InvalidPhoneNumber")
                      : undefined,
                }}
                render={({ field }) => (
                  <TextField
                    fullWidth
                    {...field}
                    value={field.value ?? ""}
                    label={t(textfield.label)}
                    inputProps={{
                      "data-testid": `clinic.edit-form.${textfield.register}-input`,
                    }}
                    error={!!errors?.clinic?.[textfield.register]}
                    helperText={
                      errors?.clinic?.[textfield.register]?.message || ""
                    }
                  />
                )}
              />
            </Grid>
          ))}
          <Grid item xs={6}>
            <CountrySelector
              preselectedValue={clinic?.country}
              testId="clinic.edit-form.country-select"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name={url}
              control={control}
              rules={{
                validate: (value) =>
                  !value ||
                  isValidWebsiteUrl(value) ||
                  t("InvalidClinicUrl"),
              }}
              render={({ field }) => (
                <TextField
                  fullWidth
                  {...field}
                  value={field.value ?? ""}
                  label={t("CopyAndPasteUrlLink")}
                  placeholder={t("CopyAndPasteUrlLink")}
                  inputProps={{ "data-testid": "clinic.edit-form.url-input" }}
                  error={!!errors?.clinic?.url}
                  helperText={errors?.clinic?.url?.message || ""}
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
}
